import { Lock } from 'lucide-react';
import { Input } from '@/components/Input';
import { useT } from '@/i18n/LocaleProvider';
import { FIXED_ADDRESS_FIELD_CLASSES } from './invitedAddress';

/**
 * I-2181, I-2229: the address an invitation fixes the sign-in or sign-up to. It is read-only, and it
 * must look it: a dashed outline instead of a field's fill or line, muted text, and a lock at its end,
 * so nobody tries to type into it. The input stays, so its label, its read-only state and its hint
 * reach a screen reader as before.
 */
export function FixedAddressField({ address, hint }: { address: string; hint: string }) {
  const t = useT();
  return (
    <Input
      id="email"
      name="invited-address"
      label={t('auth.common.email')}
      type="text"
      value={address}
      readOnly
      aria-readonly="true"
      className={FIXED_ADDRESS_FIELD_CLASSES}
      hint={hint}
      touchTarget
      trailing={
        <Lock
          data-testid="fixed-address-lock"
          aria-hidden="true"
          className="h-3.5 w-3.5 text-gray-400 dark:text-gray-500"
        />
      }
    />
  );
}
